import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { isStaff } from '../../common/typeAssertionFunctions';
import useAuthStore from '../../datastore/useAuth';


export default function CustomerSuspended() {
    const { currentUser } = useAuthStore()
    const nav = useNavigate()

    if (!currentUser || isStaff(currentUser)) {
        return null
    }

    if (currentUser.isActive) {
        nav('/')
    }

    return (
        <Stack direction="column" sx={{ height: '100%', justifyContent: 'flex-start', alignItems: 'center', padding: 3, gap: 2 }}>
            <Typography variant='h1' textAlign="center">Your account has been suspended :(</Typography>
            <Link variant='h3' href='https://tpgespresso.com/#contact'>Contact TPGE for more info.</Link>
        </Stack>
    )
}